import { Breadcrumb, Button, Descriptions, message, Popconfirm } from "antd";
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import axios from "axios";
import { SERVER_ADDRESS } from "../../../Config/Config";

const VerifyReels = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  useEffect(() => {
    console.log(data);
  }, []);
  const breadcrumbItems = [
    {
      path: "/dashboard",
      title: "Home",
    },
    {
      path: "/reels",
      title: "Reels list",
    },
  ];
  const items = [
    {
      label: "UUID",
      span: "filled",
      children: data?.uuid,
    },
    {
      label: "Name",
      span: "filled",
      children: data?.name,
    },
    {
      label: "Email",
      span: "filled",
      children: data?.email,
    },
    {
      label: "Audio",
      span: "filled",
      children: <audio type="audio/mp4" src={data.audio_url} controls />,
    },
    {
      label: "Video",
      span: "filled",
      children: (
        <>
          <video
            width="100%"
            controls
            autoPlay
            muted
            style={{
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            }}
          >
            <source
              src={data.video_url}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </>
      ),
    },
  ];

  const handleVerification = async (id, type) => {
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/verify_reels`, {
        type,
        id,
      });
      const result = response.data;
      if (result.result === 1) {
        navigate("/reels");
        message.success({ content: result.message, duration: 2 });
      }
    } catch (error) {
      message.error({ content: "Something went wrong", duration: 2 });
    }
  };

  return (
    <div style={{ marginTop: "4rem" }}>
      <div
        className="mt-3 p-4"
        style={{ backgroundColor: "white", borderRadius: "1rem" }}
      >
        <div className="d-flex flex-row justify-content-between">
          <h3 className="py-4">Verify Reels</h3>
          <Breadcrumb>
            {breadcrumbItems.map((item, index) => (
              <Breadcrumb.Item key={index}>
                <Link to={item.path}>{item.title}</Link>
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
        <div style={{ marginTop: "2rem" }}>
          <Descriptions title="User Info" bordered items={items} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              flexDirection: "row",
              gap: "1rem",
            }}
          >
            <Popconfirm
              onConfirm={() => {
                handleVerification(data?.id, "1");
              }}
              title="Are you sure want to verify ?"
            >
              <Button color="primary" variant="solid">
                Verify
              </Button>
            </Popconfirm>
            <Popconfirm
              onConfirm={() => {
                handleVerification(data?.id, "2");
              }}
              title="Are you sure want to verify ?"
            >
              <Button color="danger" variant="solid">
                Reject
              </Button>
            </Popconfirm>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyReels;
